export default __webpack_public_path__ + "32099c6ca18b7f0c525ad28215b1cd78.webp";